import React from "react";
import AOS from 'aos';

import webchat1 from '../assets/img/portfolio/webchat/1.png';
import webchat2 from '../assets/img/portfolio/webchat/2.png';
import webchat3 from '../assets/img/portfolio/webchat/3.png';

import pos1 from '../assets/img/portfolio/pos/1.png';
import pos2 from '../assets/img/portfolio/pos/2.png';
import pos3 from '../assets/img/portfolio/pos/3.png';

import car1 from '../assets/img/portfolio/rental mobil/1.png';
import car2 from '../assets/img/portfolio/rental mobil/2.png';
import car3 from '../assets/img/portfolio/rental mobil/3.png';

import dash1 from '../assets/img/portfolio/dashboard/1.png';
import dash2 from '../assets/img/portfolio/dashboard/2.png';
import dash3 from '../assets/img/portfolio/dashboard/3.png';

import klr1 from '../assets/img/portfolio/klrracing/1.png';
import klr2 from '../assets/img/portfolio/klrracing/2.png';
import klr3 from '../assets/img/portfolio/klrracing/3.png';

import st1 from '../assets/img/portfolio/satriatehnik/1.png';
import st2 from '../assets/img/portfolio/satriatehnik/2.png';
import st3 from '../assets/img/portfolio/satriatehnik/3.png';

import absen1 from '../assets/img/portfolio/absensi/1.png';
import absen2 from '../assets/img/portfolio/absensi/2.png';
import absen3 from '../assets/img/portfolio/absensi/3.png';

import boga1 from '../assets/img/portfolio/bogaswadaya/1.png';
import boga2 from '../assets/img/portfolio/bogaswadaya/2.png';
import boga3 from '../assets/img/portfolio/bogaswadaya/3.png';

import nawa1 from '../assets/img/portfolio/nawasena/1.png';
import nawa2 from '../assets/img/portfolio/nawasena/2.png';
import nawa3 from '../assets/img/portfolio/nawasena/3.png';

import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import GLightbox from 'glightbox';

const Portfolio = () => {
    React.useEffect(() => {
        /**
         *  Animation on scroll function and init
         */
        const aosInit = () => {
            AOS.init({
                duration: 600,
                easing: 'ease-in-out',
                once: true,
                mirror: false
            })
        }
        aosInit();

        /**
         * Init isotope layout and filters
         */
        document.querySelectorAll('.isotope-layout').forEach(function (isotopeItem) {
            let layout = isotopeItem.getAttribute('data-layout') ?? 'masonry';
            let filter = isotopeItem.getAttribute('data-default-filter') ?? '*';
            let sort = isotopeItem.getAttribute('data-sort') ?? 'original-order';

            let initIsotope;
            imagesLoaded(isotopeItem.querySelector('.isotope-container'), function () {
                initIsotope = new Isotope(isotopeItem.querySelector('.isotope-container'), {
                    itemSelector: '.isotope-item',
                    layoutMode: layout,
                    filter: filter,
                    sortBy: sort
                });
            });

            isotopeItem.querySelectorAll('.isotope-filters li').forEach(function (filters) {
                filters.addEventListener('click', function () {
                    isotopeItem.querySelector('.isotope-filters .filter-active').classList.remove('filter-active');
                    this.classList.add('filter-active');
                    initIsotope.arrange({
                        filter: this.getAttribute('data-filter')
                    });
                    if (typeof aosInit === 'function') {
                        aosInit();
                    }
                }, false);
            });

        });

        /**
         * Initiate glightbox
         */
        GLightbox({
            selector: '.glightbox'
        });
    }, []);

    return (
        <>
            {/* Portfolio Section */}
            <section id="portfolio" className="portfolio section light-background">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2><i className="bi bi-images navicon"></i> Portofolio</h2>
                    <p>
                        Berikut adalah hasil karya aplikasi yang telah saya kembangkan, baik berbasis web maupun desktop. Setiap proyek mencerminkan kompetensi saya dalam merancang dan membangun solusi inovatif, dengan penekanan pada fungsi, desain, serta pengalaman pengguna.
                    </p>
                </div>
                {/* End Section Title */}
                <div className="container">
                    <div
                        className="isotope-layout"
                        data-default-filter="*"
                        data-layout="masonry"
                        data-sort="original-order"
                    >
                        <ul
                            className="portfolio-filters isotope-filters"
                            data-aos="fade-up"
                            data-aos-delay={100}
                        >
                            <li data-filter="*" className="filter-active">
                                All
                            </li>
                            <li data-filter=".filter-app">Web</li>
                            <li data-filter=".filter-product">Desktop</li>
                        </ul>
                        {/* End Portfolio Filters */}
                        <div
                            className="row gy-4 isotope-container"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            {/* Start Portfolio Web Chat */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={webchat1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Web Chat</h4>
                                        <p>Aplikasi web chat ini berbasis web yang dikembangkan dengan framework
                                            <a target='_blank' rel='noreferrer' className='text-white' href='https://github.com/fajar-subhan/FS_Framework'> FS Framework</a>
                                        </p>
                                        <a
                                            href={webchat1}
                                            title="Halaman login pada aplikasi web chat"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={webchat2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Web Chat</h4>
                                        <p>Aplikasi web chat ini berbasis web yang dikembangkan dengan framework
                                            <a target='_blank' rel='noreferrer' className='text-white' href='https://github.com/fajar-subhan/FS_Framework'> FS Framework</a>
                                        </p>
                                        <a
                                            href={webchat2}
                                            title="Halaman transaksi chat"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={webchat3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Web Chat</h4>
                                        <p>Aplikasi web chat ini berbasis web yang dikembangkan dengan framework
                                            <a target='_blank' rel='noreferrer' className='text-white' href='https://github.com/fajar-subhan/FS_Framework'> FS Framework</a>
                                        </p>
                                        <a
                                            href={webchat3}
                                            title="Halaman transaksi chat"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Web Chat */}

                            {/* Start Portfolio POS */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={pos1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>POS</h4>
                                        <p>Aplikasi POS (Point of Sales) ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={pos1}
                                            title="Halaman login pada aplikasi POS (Point Of Sales)"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={pos2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>POS</h4>
                                        <p>Aplikasi POS (Point of Sales) ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={pos2}
                                            title="Halaman dashboard pada aplikasi pos (point of sales)"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={pos3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>POS</h4>
                                        <p>Aplikasi POS (Point of Sales) ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={pos3}
                                            title="Halaman transaksi pembelian barang pada aplikasi pos (point of sales)"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio POS */}

                            {/* Start Portfolio Rental Mobil */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={car1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Rental Mobil</h4>
                                        <p>Aplikasi rental mobil ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={car1}
                                            title="Halaman login pada aplikasi rental mobil"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={car2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Rental Mobil</h4>
                                        <p>Aplikasi rental mobil ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={car2}
                                            title="Halaman dashboard pada aplikasi rental mobil"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={car3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Rental Mobil</h4>
                                        <p>Aplikasi rental mobil ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={car3}
                                            title="Halaman data customer pada aplikasi rental mobil"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Rental Mobil */}

                            {/* Start Portfolio Dashboard */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={dash1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Dashboard</h4>
                                        <p>Aplikasi dashboard ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={dash1}
                                            title="Halaman login pada aplikasi dashboard"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={dash2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Dashboard</h4>
                                        <p>Aplikasi dashboard ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={dash2}
                                            title="Halaman monitoring dashboard pada aplikasi dashboard"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={dash3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Dashboard</h4>
                                        <p>Aplikasi dashboard ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={dash3}
                                            title="Halaman data list agent pada aplikasi dashboard"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Dashboard */}

                            {/* Start Portfolio KLR Racing */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={klr3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>KLR Racing</h4>
                                        <p>Aplikasi Stok & Penjualan ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={klr3}
                                            title="Halaman data penjualan pada aplikasi stok & penjualan klr racing"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={klr2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>KLR Racing</h4>
                                        <p>Aplikasi Stok & Penjualan ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={klr2}
                                            title="Halaman data pembelian pada aplikasi stok & penjualan klr racing"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={klr1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>KLR Racing</h4>
                                        <p>Aplikasi Stok & Penjualan ini dikembangkan menggunakan framework CodeIgniter.</p>
                                        <a
                                            href={klr1}
                                            title="Halaman data dashboard pada aplikasi stok & penjualan klr racing"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio KLR Racing */}


                            {/* Start Portfolio Satria Tehnik */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={st1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Satria Tehnik</h4>
                                        <p>Website portfolio & pemesanan service AC ini dikembangkan menggunakan wordpress.</p>
                                        <a
                                            href={st1}
                                            title="Halaman pertama satria tehnik"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={st2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Satria Tehnik</h4>
                                        <p>Website portfolio & pemesanan service AC ini dikembangkan menggunakan wordpress.</p>
                                        <a
                                            href={st2}
                                            title="Halaman kedua satria tehnik"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={st3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Satria Tehnik</h4>
                                        <p>Website portfolio & pemesanan service AC ini dikembangkan menggunakan wordpress.</p>
                                        <a
                                            href={st3}
                                            title="Halaman ketiga satria tehnik"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Satria Tehnik */}

                            {/* Start Portfolio Absensi */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={absen3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Absensi</h4>
                                        <p>Aplikasi absensi ini dikembangkan menggunakan framework Laravel.</p>
                                        <a
                                            href={absen3}
                                            title="Halaman untuk melakukan absensi dengan foto dan maps pada aplikasi absensi"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={absen2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Absensi</h4>
                                        <p>Aplikasi absensi ini dikembangkan menggunakan framework Laravel.</p>
                                        <a
                                            href={absen2}
                                            title="Halaman dashboard pada aplikasi absensi"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={absen1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>Absensi</h4>
                                        <p>Aplikasi absensi ini dikembangkan menggunakan framework Laravel.</p>
                                        <a
                                            href={absen1}
                                            title="Halaman login pada aplikasi absensi"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Absensi */}


                            {/* Start Portfolio Boga Swadaya */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={boga1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Boga Swadaya Catering</h4>
                                        <p>Aplikasi SPK pemilihan karyawan terbaik ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={boga1}
                                            title="Halaman login aplikasi boga swadaya catering"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={boga2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Boga Swadaya Catering</h4>
                                        <p>Aplikasi SPK pemilihan karyawan terbaik ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={boga2}
                                            title="Halaman home boga swdaya catering"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={boga3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Boga Swadaya Catering</h4>
                                        <p>Aplikasi SPK pemilihan karyawan terbaik ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={boga3}
                                            title="Halaman menu proses metode SAW boga swadaya catering"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Boga Swadaya */}


                            {/* Start Portfolio Nawasema */}
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={nawa1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Nawasena</h4>
                                        <p>Aplikasi SPK penerimaan karyawan ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={nawa1}
                                            title="Halaman login nawasena"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={nawa2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Nawasena</h4>
                                        <p>Aplikasi SPK penerimaan karyawan ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={nawa2}
                                            title="Halaman home nawasena"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <div className="portfolio-content h-100">
                                    <img
                                        src={nawa3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="portfolio-info">
                                        <h4>PT Nawasena</h4>
                                        <p>Aplikasi SPK penerimaan karyawan ini dikembangkan menggunakan Java berbasis desktop.</p>
                                        <a
                                            href={nawa3}
                                            title="Halaman menu proses penambahan pelamar kerja nawasena"
                                            data-gallery="portfolio-gallery-app"
                                            className="glightbox preview-link"
                                        >
                                            <i className="bi bi-zoom-in" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* End Portfolio Boga Swadaya */}
                        </div>
                        {/* End Portfolio Wev */}
                    </div>
                </div>
            </section>
            {/* /Portfolio Section */}
        </>
    )
}

export default Portfolio;